import { LuCheck } from "react-icons/lu";
import { useState } from "react";
import ContactSalesModal from "./contact-sales-modal";

interface PriceCardProps {
  plan: {
    name: string;
    api_payload?: string;
    price: number | string;
    priceSuffix?: string;
    badge?: string | null;
    gradientClass?: string;
    features: string[];
  };
  isAnnual: boolean;
  discount: number;
  currentPlan: string | null;
  loading: boolean;
  onUpgrade: (plan: "basic" | "pro" | "max") => void;
}

export default function PriceCard({
  plan,
  isAnnual,
  discount,
  currentPlan,
  loading,
  onUpgrade,
}: PriceCardProps) {
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <>
      <ContactSalesModal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
      />
    <div
      className={`indicator card w-full h-full bg-base-100 shadow-sm ${plan.gradientClass}`}
    >
      {plan.gradientClass && (
        <span className="indicator-item indicator-top indicator-center badge badge-xs badge-primary">
          {plan.badge}
        </span>
      )}
      <div className="card-body">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold">{plan.name}</h2>
        </div>
        <div className="mb-4">
          {typeof plan.price === "number" ? (
            <>
              <div className="flex items-baseline">
                <span className="text-4xl">$</span>
                <span className="countdown font-mono text-4xl">
                  <span
                    style={
                      {
                        "--value": isAnnual
                          ? Math.round(plan.price * (1 - discount))
                          : plan.price,
                      } as React.CSSProperties
                    }
                    aria-live="polite"
                    aria-label={`${
                      isAnnual
                        ? Math.round(plan.price * (1 - discount))
                        : plan.price
                    }`}
                  >
                    {plan.price}
                  </span>
                </span>
              </div>
            </>
          ) : (
            <span className="text-lg font-semibold">{plan.price}</span>
          )}
        </div>
        <div className="mt-4">
          <button
            type="button"
            className={`btn btn-primary btn-block ${
              plan.name === "Enterprise" ? "mt-3" : ""
            }`}
            disabled={
              loading ||
              (!!plan.api_payload && currentPlan === plan.api_payload)
            }
            onClick={() => {
              if (plan.name === "Enterprise") {
                setShowContactModal(true);
                return;
              }
              onUpgrade(plan.api_payload as "basic" | "pro" | "max");
            }}
          >
            {loading ? (
              <span className="loading loading-spinner loading-sm"></span>
            ) : plan.api_payload && currentPlan === plan.api_payload ? (
              "Current Plan"
            ) : plan.name === "Enterprise" ? (
              "Contact Sales"
            ) : (
              "Select"
            )}
          </button>
        </div>
        <ul className="mt-6 flex flex-col gap-2 text-sm">
          {plan.features.map((feature, featureIndex) => (
            <li key={featureIndex} className="flex">
              <LuCheck size={20} className="me-2 flex-shrink-0 text-success" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
    </>
  );
}
